<template>
  <div style="background-color: #f0f0f0;">
    <div v-if="$vuetify.breakpoint.mobile">
      <v-toolbar fixed flat color="white">
        <img class="pa-1" :src="logoSrc" style="height:100%;" />
        <v-spacer></v-spacer>
        <v-menu offset-y transition="scale-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="primary" dark v-bind="attrs" v-on="on">
              mdi-menu
            </v-icon>
          </template>
          <v-list>
            <v-list-item>
              <v-list-item-title
                ><a href="#opcije" style="color:#000;text-decoration:none;"
                  >Šta je SABIRA?</a
                ></v-list-item-title
              >
            </v-list-item>
            <v-list-item>
              <v-list-item-title
                ><a href="#licence" style="color:#000;text-decoration:none;"
                  >Aktiviraj</a
                ></v-list-item-title
              >
            </v-list-item>
            <v-list-item>
              <v-list-item-title
                ><a
                  href="#payment_type"
                  style="color:#000;text-decoration:none;"
                  >Način plaćanja</a
                ></v-list-item-title
              >
            </v-list-item>
            <v-list-item>
              <v-list-item-title
                ><a href="#sec" style="color:#000;text-decoration:none;"
                  >Sigurnost</a
                ></v-list-item-title
              >
            </v-list-item>
            <v-list-item>
              <v-list-item-title
                ><a href="#faq" style="color:#000;text-decoration:none;"
                  >FAQ</a
                ></v-list-item-title
              >
            </v-list-item>
            <v-list-item>
              <v-list-item-title
                ><a @click="contact_us()" style="color:#000;"
                  >Kontakt</a
                ></v-list-item-title
              >
            </v-list-item>
            <v-list-item>
              <v-list-item-title
                ><a href="#video" style="color:#000;text-decoration:none;"
                  >Video</a
                ></v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>
      <v-divider></v-divider>
    </div>

    <div
      v-else
      class="pa-6"
      style="grid-column-gap:2rem;display:grid;align-items:center;grid-template-columns: repeat(8,max-content) 1fr max-content;"
    >
      <img :src="logoSrc" style="height:5rem;" class="ma-4" />
      <a
        class="mx-auto"
        href="#opcije"
        style="text-decoration: none;color:black;"
      >
        Šta je SABIRA?</a
      >
      <a
        href="#licence"
        class="mx-auto"
        style="text-decoration: none;color:black;"
        >Aktivacija</a
      >
      <a
        href="#payment_type"
        class="mx-auto"
        style="text-decoration: none;color:black;"
        >Način plaćanja</a
      >
      <a href="#sec" class="mx-auto" style="text-decoration: none;color:black;"
        >Sigurnost</a
      >
      <a href="#faq" class="mx-auto" style="text-decoration: none;color:black;"
        >FAQ</a
      >
      <a
        style="text-decoration: none;color:black;"
        @click="contact_us()"
        class="mx-auto"
        >Kontakt</a
      >
      <a
        href="#video"
        class="mx-auto"
        style="text-decoration: none;color:black;"
        >Video</a
      >
      <div></div>
      <div
        v-if="$vuetify.breakpoint.lgOnly || $vuetify.breakpoint.xlOnly"
        style="display:inline;float:right;"
      >
        <v-btn href="/login" class="ma-4" color="primary">Login</v-btn>
      </div>
    </div>

    <v-container fluid class="pa-8">
      <div>
        <div class="pa-2 pt-0">
          <div style="text-align:left;">
            <div :class="'spacing_' + $vuetify.breakpoint.name">
              <div :class="'headline_' + $vuetify.breakpoint.name">
                Digitalna transformacija <br />poslovanja.
              </div>
              <div :class="'subtitle_' + $vuetify.breakpoint.name">
                Jednostavan alat za efektivno poslovanje obrta, malih i srednjih
                firmi.<br />
                Upravljajte ključnim aspektima svog poslovanja koristeći
                prednosti napredne tehnologije.
              </div>

              <v-container
                class="mt-4 pa-0"
                style="display:inline-block;text-align:left;"
              >
                <v-row>
                  <v-col cols="12" lg="2" xl="2">
                    <v-btn href="#opcije" outlined x-large>Saznajte više</v-btn>
                  </v-col>
                  <v-col cols="12" lg="2" xl="2">
                    <v-btn
                      href="#licence"
                      outlined
                      class="primary white--text"
                      x-large
                      >Registracija</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </div>
        </div>
        <div v-if="$vuetify.breakpoint.mobile">
          <v-img
            cover
            :src="imageAm"
            class="pa-2 mr-2"
            style="margin-top:1.8rem;border-radius: 1.5rem;padding-right: 2rem;"
          />
        </div>
        <v-container fluid>
          <v-row>
            <v-col>
              <v-sheet
                :class="'hero_0_' + $vuetify.breakpoint.name"
                :style="{
                  'background-image':
                    'url(https://sabira.ba/img/sabira_ch.png)',
                }"
              >
              </v-sheet>
            </v-col>
            <v-col>
              <v-sheet
                :class="'hero_1_' + $vuetify.breakpoint.name"
                :style="{
                  'background-color': 'transparent',
                  'background-image':
                    'url(https://sabira.ba/img/logo_services.svg)',
                }"
              >
              </v-sheet>
            </v-col>
            <v-col>
              <v-sheet
                :class="'hero_2_' + $vuetify.breakpoint.name"
                :style="{
                  'background-image':
                    'url(https://sabira.ba/img/sabira_am.png)',
                }"
              >
              </v-sheet>
            </v-col>
          </v-row>
        </v-container>
        <div id="opcije"></div>
        <div class="pa-2 pt-0">
          <div style="text-align:left;">
            <div :class="'spacing_' + $vuetify.breakpoint.name">
              <div :class="'headline_' + $vuetify.breakpoint.name">
                Biznis sabran.<br />
                U svakom pogledu.
              </div>
              <div :class="'subtitle_' + $vuetify.breakpoint.name">
                SABIRA je jedinstveno okruženje koje omogućava unapređenje
                ključnih poslovnih procesa. Od standardizacije interne
                dokumentacije pa sve do optimizacije prihoda, SABIRA je Vaš
                svakodnevni asistent.
              </div>
            </div>
          </div>
        </div>

        <v-container fluid class="pa-2 pt-0">
          <v-row>
            <v-col cols="12" lg="4" md="6" sm="6" xs="12" xl="3">
              <v-sheet :class="'primary module_' + $vuetify.breakpoint.name">
                <div
                  class="text-center"
                  style="display:grid;align-items:center;"
                >
                  <sabira_icon
                    icon="invoice"
                    fill="white"
                    class="icon mx-auto"
                    :width="200"
                    :height="200"
                    :strokewidth="1"
                  ></sabira_icon>
                  <div class="module_title">
                    Fakture
                  </div>
                </div>

                <div class="text">
                  100% personalizacija<br />
                  Logo firme, e-potpis i e-pečat<br />
                  Ulazne i izlazne fakture<br />
                  Podrška fiskalne numeracije<br />
                  Kreiranje PDF dokumenta<br />
                  Slanje putem Email poruke<br />
                  Kopiranje u novu fakturu
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="12" lg="4" md="6" sm="6" xs="12" xl="3">
              <v-sheet :class="'primary module_' + $vuetify.breakpoint.name">
                <div
                  class="text-center"
                  style="display:grid;align-items:center;justify-content:center;"
                >
                  <sabira_icon
                    icon="offer"
                    fill="white"
                    class="icon mx-auto"
                    :width="200"
                    :height="200"
                    :strokewidth="1"
                  ></sabira_icon>
                  <div class="module_title">
                    Ponude
                  </div>
                </div>

                <div class="text">
                  100% personalizacija<br />
                  Logo firme, e-potpis i e-pečat<br />
                  Kreiranje PDF dokumenta<br />
                  Slanje putem Email poruke<br />
                  Kopiranje u novu ponudu<br />
                  Kopiranje u fakturu
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="12" lg="4" md="6" sm="6" xs="12" xl="3">
              <v-sheet :class="'primary module_' + $vuetify.breakpoint.name">
                <div
                  class="text-center"
                  style="display:grid;align-items:center;"
                >
                  <sabira_icon
                    icon="product"
                    fill="white"
                    class="icon mx-auto"
                    :width="200"
                    :height="200"
                    :strokewidth="1"
                  ></sabira_icon>
                  <div class="module_title">
                    Proizvodi
                  </div>
                </div>

                <div class="text">
                  Upravljanje šifarnikom<br />
                  Višestruke PDV stope<br />
                  Analitika prometa<br />
                  Filteri za ključne stavke<br />
                  Cjenovnik PDF<br />
                  Slanje putem Email poruke
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="12" lg="4" md="6" sm="6" xs="12" xl="3">
              <v-sheet :class="'primary module_' + $vuetify.breakpoint.name">
                <div
                  class="text-center"
                  style="display:grid;align-items:center;"
                >
                  <sabira_icon
                    icon="client"
                    fill="white"
                    class="mx-auto icon"
                    :width="200"
                    :height="200"
                    :strokewidth="1"
                  ></sabira_icon>
                  <div class="module_title">
                    Klijenti
                  </div>
                </div>

                <div class="text">
                  Upravljanje šifarnikom<br />
                  Kartice klijenata i IOS-i<br />
                  Prometi, uplate, dugovanja<br />
                  Dinamičke kategorije<br />
                  Analitika poslovanja<br />
                  Integrisan email sistem<br />
                  PDF dokumenti
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="12" lg="4" md="6" sm="6" xs="12" xl="3">
              <v-sheet :class="'primary module_' + $vuetify.breakpoint.name">
                <div
                  class="text-center"
                  style="display:grid;align-items:center;"
                >
                  <sabira_icon
                    icon="supplier"
                    fill="white"
                    class="mx-auto icon"
                    :width="200"
                    :height="200"
                    :strokewidth="1"
                  ></sabira_icon>
                  <div class="module_title">
                    Dobavljači
                  </div>
                </div>

                <div class="text">
                  Upravljanje šifarnikom<br />
                  Prometi po dobavljaču<br />
                  Dugovanja po dobavljaču<br />
                  Filteri po stavkama dobavljača
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="12" lg="4" md="6" sm="6" xs="12" xl="3">
              <v-sheet :class="'primary module_' + $vuetify.breakpoint.name">
                <div
                  class="text-center"
                  style="display:grid;align-items:center;"
                >
                  <sabira_icon
                    icon="contract"
                    fill="white"
                    class="mx-auto icon"
                    :width="200"
                    :height="200"
                    :strokewidth="1"
                  ></sabira_icon>
                  <div class="module_title">
                    Ugovori
                  </div>
                </div>

                <div class="text">
                  Evidencija tekućih ugovora<br />
                  Automatsko praćenje trajanja<br />
                  Integracija ugovora sa klijentima<br />
                  Integracija ugovora sa fakturama
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="12" lg="4" md="6" sm="6" xs="12" xl="3">
              <v-sheet :class="'primary module_' + $vuetify.breakpoint.name">
                <div
                  class="text-center"
                  style="display:grid;align-items:center;"
                >
                  <sabira_icon
                    icon="order"
                    fill="white"
                    class="mx-auto icon"
                    :width="200"
                    :height="200"
                    :strokewidth="1"
                  ></sabira_icon>
                  <div class="module_title">
                    Narudžbe
                  </div>
                </div>

                <div class="text">
                  Upravljanje dobavljačima<br />
                  Lista usluga, materijala i količine<br />
                  Praćenje statusa i isporuke<br />
                  PDF dokumenti<br />
                  Integrisan email sistem
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="12" lg="4" md="6" sm="6" xs="12" xl="3">
              <v-sheet :class="'primary module_' + $vuetify.breakpoint.name">
                <div
                  class="text-center"
                  style="display:grid;align-items:center;"
                >
                  <sabira_icon
                    icon="stock"
                    fill="white"
                    class="mx-auto icon"
                    :width="200"
                    :height="200"
                    :strokewidth="1"
                  ></sabira_icon>
                  <div class="module_title">
                    Zalihe
                  </div>
                </div>

                <div class="text">
                  Upravljanje zalihama<br />
                  Evidencija ulaza i izlaza<br />
                  Automatske otpremnice<br />
                  Upravljanje povratima<br />
                  Otpis i popis zaliha<br />
                  PDF dokumenti<br />
                  Integrisan email sistem
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="12" lg="4" md="6" sm="6" xs="12" xl="3">
              <v-sheet :class="'primary module_' + $vuetify.breakpoint.name">
                <div
                  class="text-center"
                  style="display:grid;align-items:center;"
                >
                  <sabira_icon
                    icon="work_order"
                    fill="white"
                    class="mx-auto icon"
                    :width="200"
                    :height="200"
                    :strokewidth="1"
                  ></sabira_icon>
                  <div class="module_title">
                    Radni nalozi
                  </div>
                </div>

                <div class="text">
                  Upravljanje klijentima<br />
                  Opisi poslova i statusi<br />
                  Lista materijala i količine<br />
                  PDF dokumenti<br />
                  Integrisan email sistem<br />
                  Kopiranje u novu fakturu
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="12" lg="4" md="6" sm="6" xs="12" xl="3">
              <v-sheet :class="'primary module_' + $vuetify.breakpoint.name">
                <div
                  class="text-center"
                  style="display:grid;align-items:center;"
                >
                  <sabira_icon
                    icon="asset"
                    fill="white"
                    :width="200"
                    :height="200"
                    class="mx-auto icon"
                    :strokewidth="1"
                  ></sabira_icon>
                  <div class="module_title">
                    Sredstva
                  </div>
                </div>

                <div class="text">
                  Evidencija stalnih sredstava<br />
                  Izračun amortizacije<br />
                  Kreiranje PDF dokumenta<br />
                  Slanje putem Email poruke<br />
                  Kopiranje u narednu godinu
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="12" lg="4" md="6" sm="6" xs="12" xl="3">
              <v-sheet :class="'primary module_' + $vuetify.breakpoint.name">
                <div
                  class="text-center"
                  style="display:grid;align-items:center;"
                >
                  <sabira_icon
                    icon="expense"
                    fill="white"
                    :width="200"
                    :height="200"
                    class="mx-auto icon"
                    :strokewidth="1"
                  ></sabira_icon>
                  <div class="module_title">
                    Prihodi i troškovi
                  </div>
                </div>

                <div class="text">
                  Evidencija uplata klijenata<br />
                  Evidencija isplata dobavljačima<br />
                  Analiza prihoda i rashoda<br />
                  Prikaz preostalih uplata i isplata<br />
                  Procentualni i apsolutni prikaz
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="12" lg="4" md="6" sm="6" xs="12" xl="3">
              <v-sheet :class="'primary module_' + $vuetify.breakpoint.name">
                <div
                  class="text-center"
                  style="display:grid;align-items:center;"
                >
                  <sabira_icon
                    icon="chart"
                    fill="white"
                    :width="200"
                    :height="200"
                    class="mx-auto icon"
                    :strokewidth="1"
                  ></sabira_icon>
                  <div class="module_title">
                    Izvještaji
                  </div>
                </div>

                <div class="text">
                  Ključni poslovni indikatori<br />
                  Mjesečni i godišnji izvještaji<br />
                  Podrška za do 5 prethodnih godina<br />
                  Procentualni i apsolutni prikazi<br />
                  Višestruka analitika poslovanja
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="12" lg="4" md="6" sm="6" xs="12" xl="3">
              <v-sheet :class="'primary module_' + $vuetify.breakpoint.name">
                <div
                  class="text-center"
                  style="display:grid;align-items:center;"
                >
                  <sabira_icon
                    icon="marketing"
                    fill="white"
                    :width="200"
                    :height="200"
                    class="mx-auto icon"
                    :strokewidth="1"
                  ></sabira_icon>
                  <div class="module_title">
                    Marketing
                  </div>
                </div>

                <div class="text">
                  Kreiranje marketing budžeta<br />
                  Kreiranje marketing kampanja<br />
                  Evidencija troškova<br />
                  Marketing ciljevi<br />
                  Povrat investicije (ROI)
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="12" lg="4" md="6" sm="6" xs="12" xl="3">
              <v-sheet :class="'primary module_' + $vuetify.breakpoint.name">
                <div
                  class="text-center"
                  style="display:grid;align-items:center;"
                >
                  <sabira_icon
                    icon="employees"
                    fill="white"
                    :width="200"
                    :height="200"
                    class="mx-auto icon"
                    :strokewidth="1"
                  ></sabira_icon>
                  <div class="module_title">
                    HR
                  </div>
                </div>

                <div class="text">
                  Baza uposlenika sa podacima<br />
                  Evidencija radnog vremena<br />
                  Kalkulator ličnog dohodka<br />
                  Evidencija ličnih dohodaka<br />
                  Pozicije i struktura firme
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="12" lg="4" md="6" sm="6" xs="12" xl="3">
              <v-sheet :class="'primary module_' + $vuetify.breakpoint.name">
                <div
                  class="text-center"
                  style="display:grid;align-items:center;"
                >
                  <sabira_icon
                    icon="goal"
                    fill="white"
                    :width="200"
                    :height="200"
                    class="mx-auto icon"
                    :strokewidth="1"
                  ></sabira_icon>
                  <div class="module_title">
                    PR
                  </div>
                </div>

                <div class="text">
                  Performance Review<br />
                  Ocjena uspješnosti<br />
                  Vremenski periodi ocjenjivanja<br />
                  Kreiranje struktuiranih ciljeva<br />
                  Fokus i produktivnost<br />
                  Povećanje zadovoljstva
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="12" lg="4" md="6" sm="6" xs="12" xl="3">
              <v-sheet :class="'primary module_' + $vuetify.breakpoint.name">
                <div
                  class="text-center"
                  style="display:grid;align-items:center;"
                >
                  <sabira_icon
                    icon="calendar"
                    fill="white"
                    :width="200"
                    :height="200"
                    class="mx-auto icon"
                    :strokewidth="1"
                  ></sabira_icon>
                  <div class="module_title">
                    Kalendar
                  </div>
                </div>

                <div class="text">
                  Kreiranje događaja<br />
                  4 pregleda događaja<br />
                  Boje prioriteta<br />
                  Frekvencije ponavljanja<br />
                  Alarmi i podsjetnici<br />
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="12" lg="4" md="6" sm="6" xs="12" xl="3">
              <v-sheet :class="'primary module_' + $vuetify.breakpoint.name">
                <div
                  class="text-center"
                  style="display:grid;align-items:center;"
                >
                  <sabira_icon
                    icon="todo"
                    fill="white"
                    :width="200"
                    :height="200"
                    class="mx-auto icon"
                    :strokewidth="1"
                  ></sabira_icon>
                  <div class="module_title">
                    Bilješke
                  </div>
                </div>

                <div class="text">
                  Drag & Drop bilješke<br />
                  Kanban pregled bilješki<br />
                  Todo, In progress, Done<br />
                  Mapiranje i vizualizacija<br />
                  Fokus i produktivnost
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="12" lg="4" md="6" sm="6" xs="12" xl="3">
              <v-sheet :class="'primary module_' + $vuetify.breakpoint.name">
                <div
                  class="text-center"
                  style="display:grid;align-items:center;"
                >
                  <sabira_icon
                    icon="memo"
                    fill="white"
                    :width="200"
                    :height="200"
                    class="mx-auto icon"
                    :strokewidth="1"
                  ></sabira_icon>
                  <div class="module_title">
                    Memo (Dopis)
                  </div>
                </div>

                <div class="text">
                  Moderni memorandum<br />
                  Dodavanje klijenata<br />
                  Interni/Eksterni dopis<br />
                  Email i PDF funkcionalnost<br />
                  Kreiranje predmeta i sadržaja
                </div>
              </v-sheet>
            </v-col>
          </v-row>
        </v-container>

        <div class="pa-2 pt-0">
          <div style="text-align:left;">
            <div :class="'spacing_' + $vuetify.breakpoint.name">
              <div :class="'headline_' + $vuetify.breakpoint.name">
                Besplatno.<br />
                Za sve koji tek počinju.
              </div>
              <div :class="'subtitle_' + $vuetify.breakpoint.name">
                Ukoliko nemate potrebe za više od 2 fakture mjesečno, SABIRA Vam
                je neograničeno dostupna besplatno. Kada je za poslovanje
                potrebno više, na raspolaganju Vam je i Profesionalna verzija.
              </div>
            </div>
          </div>
        </div>

        <v-container class="pa-0">
          <v-row>
            <v-col cols="12" lg="6" xs="12" xl="6">
              <v-sheet
                class="pa-4 rounded"
                style="border-radius: 1rem !important;border:solid 1.5px rgba(51,51,51,0.25) !important;"
                color="transparent"
              >
                <div class="text-body-1 pl-4" style="opacity:1;color: #023047;">
                  Besplatna verzija
                </div>
                <div
                  class="pa-6"
                  style="display:grid;align-items:center;grid-row-gap:1rem;"
                >
                  <div :class="'text-center cta_' + $vuetify.breakpoint.name">
                    Do 2 fakture mjesečno
                  </div>
                  <div
                    class="text-center"
                    style="font-size: 1.25rem; color: #023047;"
                  >
                    Registrujte se sa par klikova i počnite <br />neograničeno
                    koristiti sve module.
                  </div>
                </div>
                <div style="text-align:center;" class="pa-0">
                  <v-btn x-large light outlined @click="open_registration(1)">
                    Registracija
                  </v-btn>
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="12" lg="6" xs="12" xl="6">
              <v-sheet
                class="pa-4 rounded"
                style="border-radius: 1rem !important;border:solid 1.5px rgba(25, 83, 145, 1) !important;"
                color="transparent"
              >
                <div class="text-body-1 pl-4" style="opacity:1;color: #023047;">
                  Profesionalna verzija
                </div>
                <div
                  class="pa-6"
                  style="display:grid;align-items:center;grid-row-gap:1rem;"
                >
                  <div :class="'text-center cta_' + $vuetify.breakpoint.name">
                    Više od 2 fakture mjesečno
                  </div>
                  <div
                    class="text-center"
                    style="font-size: 1.25rem; color: #023047;"
                  >
                    Vaše poslovanje zahtjeva više? <br />Aktivirajte
                    Profesionalnu verziju.
                  </div>
                </div>
                <div style="text-align:center;" class="pa-0">
                  <v-btn
                    x-large
                    light
                    color="primary"
                    @click="open_registration(2)"
                  >
                    Registracija
                  </v-btn>
                </div>
              </v-sheet>
            </v-col>
          </v-row>
        </v-container>

        <div class="pa-2 pt-0">
          <div style="text-align:left;">
            <div :class="'spacing_' + $vuetify.breakpoint.name">
              <div :class="'headline_' + $vuetify.breakpoint.name">
                Dark mode.<br />
                Zato što ste Vi to tražili.
              </div>
              <div :class="'subtitle_' + $vuetify.breakpoint.name">
                Slušamo korisnike - Za korisnike koji prate trendove, a
                preferiraju bolji kontrast i manje osvjetljenje ekrana omogućili
                smo tamni način rada (Dark Mode) u svim funkcionalnostima, u
                cijeloj aplikaciji.
              </div>
            </div>
          </div>
        </div>

        <v-container fluid mb-0 mt-0 pa-0 style="width:100%">
          <v-sheet
            class="pa-4 rounded"
            style="border-radius: 1rem !important;border:solid 1.5px rgba(51,51,51,0.25) !important;"
            color="transparent"
          >
            <VueCompareImage
              leftImage="https://sabira.ba/img/sabira_light_mode.png"
              rightImage="https://sabira.ba/img/sabira_dark_mode.png"
            />
          </v-sheet>
        </v-container>

        <div class="pl-2 pt-0 mb-0 pb-0 pr-2">
          <div style="text-align:left;">
            <div :class="'spacing_' + $vuetify.breakpoint.name">
              <div :class="'headline_' + $vuetify.breakpoint.name">
                Biznis iz džepa - SABIRA iOS.<br />
                Vodite poslovanje u pokretu, bez kompromisa!
              </div>
              <div :class="'subtitle_' + $vuetify.breakpoint.name">
                SABIRA poslovna platforma za iOS (iPhone) sada je dostupna na
                App Store-u. Pristup je omogućen svim registrovanim
                korisnicima.<br />
              </div>
              <div
                style="margin-bottom:-1.5rem;"
                v-if="$vuetify.breakpoint.mobile"
              >
                <a
                  href="https://apps.apple.com/us/app/sabira/id6740875331"
                  style="text-decoration: none;"
                  target="_blank;"
                >
                  <img :src="sabiraIos" width="60%" />
                </a>
              </div>
              <div style="margin-bottom:-2.5rem;" v-else>
                <a
                  href="https://apps.apple.com/us/app/sabira/id6740875331"
                  style="text-decoration: none;"
                  target="_blank;"
                >
                  <img :src="sabiraIos" width="25%" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <v-container fluid mb-0 mt-0 pa-0>
          <v-col
            v-if="$vuetify.breakpoint.mobile"
            style="text-align:center;margin-top:3rem;"
            class="pl-0 pr-0 ml-0 mr-0"
          >
            <img src="https://sabira.ba/img/SABIRA_ios.png" width="100%" />
          </v-col>
          <v-col v-else style="text-align:center;margin-top:0px;">
            <img src="https://sabira.ba/img/SABIRA_ios.png" width="60%" />
          </v-col>
        </v-container>

        <div class="pa-2 pt-0">
          <div style="text-align:left;">
            <div :class="'spacing_' + $vuetify.breakpoint.name">
              <div :class="'headline_' + $vuetify.breakpoint.name">
                Za svakoga.<br />
                Za profesionalce, za firme.
              </div>
              <div :class="'subtitle_' + $vuetify.breakpoint.name">
                Inspirisani svakodnenim izazovima sa kojima se firme susreću,
                upotrebom napredne tehnologije i procesima automatizacije i
                standardizacije, kreirali smo radno okruženje koje Vam omogućava
                da se fokusirate na ono što volite, dok SABIRA rješava sve
                ostalo.
              </div>
            </div>
          </div>
        </div>

        <v-container fluid class="pa-0">
          <v-row>
            <v-col cols="12" lg="4" xs="12">
              <v-sheet
                dark
                style="background-image: url('https://sabira.ba/img/sabira_avail.png'"
                color="white"
                class="sub_section"
              >
                <div class="sub_section_bottom primary">
                  <div>
                    <div class="text">Dostupno</div>
                    <div class="description">
                      Bilo gdje. Bilo kada.
                    </div>
                  </div>
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="12" lg="4" xs="12">
              <v-sheet
                dark
                style="background-image: url('https://sabira.ba/img/sabira_for_all.png'"
                color="white"
                class="sub_section"
              >
                <div class="sub_section_bottom primary">
                  <div>
                    <div class="text">Jednostavno</div>
                    <div class="description">
                      Za svakoga.
                    </div>
                  </div>
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="12" lg="4" xs="12">
              <v-sheet
                dark
                style="background-image: url('https://sabira.ba/img/sabira_ai.png'"
                color="white"
                class="sub_section"
              >
                <div class="sub_section_bottom primary">
                  <div>
                    <div class="text">Napredno</div>
                    <div class="description">
                      Najnovija tehnologija.
                    </div>
                  </div>
                </div>
              </v-sheet>
            </v-col>
          </v-row>
        </v-container>
        <div id="licence"></div>
        <div class="pa-2 pt-0">
          <div style="text-align:left;">
            <div :class="'spacing_' + $vuetify.breakpoint.name">
              <div :class="'headline_' + $vuetify.breakpoint.name">
                SABIRA verzije.<br />
                Detaljni mjesečni planovi.
              </div>
              <div :class="'subtitle_' + $vuetify.breakpoint.name">
                Besplatna verzija sa svim funkcionalnostima -
                <i>limit na fakturama do 2 mjesečno.</i><br />Profesionalna
                verzija <i>bez limita.</i><br />Korporativna verzija
                <i>bez limita za više korisnika iste firme.</i>
              </div>
            </div>
          </div>
        </div>

        <v-container fluid class="pa-0">
          <v-row>
            <v-col cols="12" lg="4" sm="12" md="4" xs="12">
              <v-sheet
                light
                class="rounded"
                style="border-radius: 1.5rem !important;position:relative;overflow:hidden;"
                color="white"
              >
                <div
                  style="text-align:center;"
                  class="primary white--text pa-2"
                >
                  <div class="pa-2 pb-0 title">Besplatna verzija</div>
                  <div style="text-align:center;font-size:2.5rem;">
                    0 KM
                    <div style="font-size:1.3rem">mjesečno</div>
                  </div>
                </div>
                <v-list
                  style="background: transparent;font-size:1.2rem;color: #023047;"
                >
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    1 korisnički pristup
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Do 2 fakture mjesečno
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Neograničen broj ponuda
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Neograničen broj klijenata
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Neograničen broj dobavljača
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Neograničen broj artikala
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Neograničen broj narudžbi
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Neograničen broj naloga
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Kreiranje PDF dokumenata
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Integrisan email sistem
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon> Logo
                    firme na dokumentima
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Elektronski pečat i potpis
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Korisnička email podrška
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Kompletan HR modul
                  </v-list-item>
                </v-list>
                <div style="text-align:center;" class="pa-4 primary">
                  <v-btn x-large dark outlined @click="open_registration(1)">
                    Registracija
                  </v-btn>
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="12" lg="4" sm="12" md="4" xs="12">
              <v-sheet
                light
                class="rounded"
                style="border-radius: 1.5rem !important;position:relative;overflow:hidden;"
                color="white"
              >
                <div
                  style="text-align:center;"
                  class="primary white--text pa-2"
                >
                  <div class="pa-2 pb-0 title">Profesionalna verzija</div>
                  <div
                    style="text-align:center;font-size:2.5rem;align-items:center;"
                  >
                    <span class="body-1 mr-2">samo</span>10 KM
                    <div style="font-size:1.3rem">mjesečno</div>
                  </div>
                </div>
                <v-list
                  style="background: transparent;font-size:1.2rem;color: #023047;"
                >
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    1 korisnički pristup
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Neograničen broj faktura
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Neograničen broj ponuda
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Neograničen broj klijenata
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Neograničen broj dobavljača
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Neograničen broj artikala
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Neograničen broj narudžbi
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Neograničen broj naloga
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Kreiranje PDF dokumenata
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Integrisan email sistem
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon> Logo
                    firme na dokumentima
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Elektronski pečat i potpis
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Korisnička email podrška
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Kompletan HR modul
                  </v-list-item>
                </v-list>
                <div style="text-align:center;" class="pa-4 primary">
                  <v-btn x-large dark outlined @click="open_registration(2)">
                    Registracija
                  </v-btn>
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="12" lg="4" sm="12" md="4" xs="12">
              <v-sheet
                light
                style="border-radius: 1.5rem !important;position:relative;overflow:hidden;"
                color="white"
              >
                <div
                  style="text-align:center;"
                  class="primary white--text pa-2"
                >
                  <div class="pa-2 pb-0 title">Korporativna verzija</div>
                  <div
                    style="text-align:center;font-size:2.5rem;align-items:center;"
                  >
                    po zahtjevu
                    <div style="font-size:1.3rem">&nbsp;</div>
                  </div>
                </div>
                <v-list
                  style="background: transparent;font-size:1.2rem;color: #023047;"
                >
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Više korisnika
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Neograničen broj faktura
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Neograničen broj ponuda
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Neograničen broj klijenata
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Neograničen broj dobavljača
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Neograničen broj artikala
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Neograničen broj narudžbi
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Neograničen broj naloga
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Kreiranje PDF dokumenata
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Integrisan email sistem
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon> Logo
                    firme na dokumentima
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Elektronski pečat i potpis
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Korisnička email podrška
                  </v-list-item>
                  <v-list-item>
                    <sabira_icon class="mr-2" icon="plus"></sabira_icon>
                    Kompletan HR modul
                  </v-list-item>
                </v-list>
                <div style="text-align:center;" class="pa-4 primary">
                  <v-btn x-large dark outlined @click="contact_us()">
                    Kontaktirajte nas
                  </v-btn>
                </div>
              </v-sheet>
            </v-col>
          </v-row>
        </v-container>
        <div class="text-body1 text-center mt-4">
          * Porez je uključen u cijenu.
        </div>
        <div id="payment_type"></div>
        <div class="pa-2 pt-0">
          <div style="text-align:left;">
            <div :class="'spacing_' + $vuetify.breakpoint.name">
              <div :class="'headline_' + $vuetify.breakpoint.name">
                Način plaćanja.<br />
                Kartično ili virmanski, izbor je Vaš.
              </div>
              <div :class="'subtitle_' + $vuetify.breakpoint.name">
                Za SABIRA Profesionalna verzija, pored kompetitivne cijene
                licenci, omogućili smo korisnicima jednostavne načine aktivacije
                licenci i plaćanja. Korisnici mogu izvršiti uplatu kartično kroz
                proces registracije i naknadno u aplikaciji, ili putem virmaske
                uplate.
              </div>
            </div>
          </div>
        </div>

        <v-container fluid class="pa-0 ma-0">
          <v-row>
            <v-col cols="12" lg="6" xs="12" xl="6">
              <div style="text-align:center;" class="mb-2">
                KARTIČNO PLAĆANJE - INFO
              </div>
              <v-stepper
                v-model="e1"
                flat
                outlined
                style="background-color:transparent;border-radius: 1.5rem;border:solid 1.5px rgba(51,51,51,0.25) !important;"
              >
                <v-stepper-header>
                  <v-stepper-step :complete="e1 > 1" step="1">
                    Registracija
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step :complete="e1 > 2" step="2">
                    Uplata
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step step="3">
                    Naredna uplata
                  </v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>
                  <v-stepper-content step="1">
                    <v-sheet
                      class="pa-4 rounded"
                      style="border-radius: 1rem !important;border:solid 1px rgb(108,173,216) !important;"
                      color="primary"
                    >
                      <v-card-title
                        class="white--text"
                        style="font-size:1.2rem;"
                      >
                        Registracija
                      </v-card-title>
                      <v-card-text
                        class="white--text"
                        style="font-size:1.1rem;"
                      >
                        <p>
                          Kartično plaćanje možete izvršiti prilikom
                          registracije SABIRA Profesionalna verzija.<br />
                          Nakon ispunjenih matičnih podataka bit će Vam ponuđena
                          opcija kartičnog plaćanja. Višemjesečni bonus
                          dostupan!<br />
                        </p>
                        <v-btn
                          @click="open_registration(2)"
                          class="mb-n2 ml-0 mr-0 mt-n2 pa-0"
                          color="white"
                          style="text-decoration: underline;font-size:1.1rem;"
                          plain
                          >REGISTRUJ SE OVDJE!</v-btn
                        >
                      </v-card-text>
                    </v-sheet>
                    <br />
                    <v-btn icon color="primary" @click="e1 = 1">
                      <sabira_icon
                        icon="slide_sign"
                        :width="28"
                        :height="28"
                        fill="#195391"
                      ></sabira_icon> </v-btn
                    ><v-btn icon color="primary" @click="e1 = 2">
                      <sabira_icon
                        icon="slide_sign"
                        :width="28"
                        :height="28"
                        fill="#195391"
                      ></sabira_icon> </v-btn
                    ><v-btn icon color="primary" @click="e1 = 3">
                      <sabira_icon
                        icon="slide_sign"
                        :width="28"
                        :height="28"
                        fill="#195391"
                      ></sabira_icon>
                    </v-btn>
                  </v-stepper-content>

                  <v-stepper-content step="2">
                    <v-sheet
                      class="pa-4 rounded"
                      style="border-radius: 1rem !important;border:solid 1px rgb(108,173,216) !important;"
                      color="primary"
                    >
                      <v-card-title
                        class="white--text"
                        style="font-size:1.2rem;"
                      >
                        Uplata
                      </v-card-title>
                      <v-card-text
                        class="white--text"
                        style="font-size:1.1rem;"
                      >
                        <p>
                          Uplatu vršite kartičnim plaćanjem koristeći
                          <a
                            href="https://monri.com/"
                            target="_blank"
                            style="color:#fff;text-decoration:underline;"
                            >Monri Payments sistem</a
                          >. Transfer uplate se vrši putem UniCredit Bank Bosna
                          i Hercegovina.<br />Nakon uspješne uplate, Vaša
                          licenca će biti aktivirana i automatski će te biti
                          preusmjereni u aplikaciju.
                        </p>
                        <br />
                      </v-card-text>
                    </v-sheet>
                    <br />
                    <v-btn icon color="primary" @click="e1 = 1">
                      <sabira_icon
                        icon="slide_sign"
                        :width="28"
                        :height="28"
                        fill="#195391"
                      ></sabira_icon> </v-btn
                    ><v-btn icon color="primary" @click="e1 = 2">
                      <sabira_icon
                        icon="slide_sign"
                        :width="28"
                        :height="28"
                        fill="#195391"
                      ></sabira_icon> </v-btn
                    ><v-btn icon color="primary" @click="e1 = 3">
                      <sabira_icon
                        icon="slide_sign"
                        :width="28"
                        :height="28"
                        fill="#195391"
                      ></sabira_icon>
                    </v-btn>
                  </v-stepper-content>

                  <v-stepper-content step="3">
                    <v-sheet
                      class="pa-4 rounded"
                      style="border-radius: 1rem !important;border:solid 1px rgb(108,173,216) !important;"
                      color="primary"
                    >
                      <v-card-title
                        class="white--text"
                        style="font-size:1.2rem;"
                      >
                        Uplata u aplikaciji
                      </v-card-title>
                      <v-card-text
                        class="white--text"
                        style="font-size:1.1rem;"
                      >
                        <p>
                          Narednu uplatu možete izvršiti direktno u aplikaciji,
                          u korisničkim postavkama.<br />
                          KORISNIK => POSTAVKE => FAKTURA => UPLATI<br />
                          Napomena: trajanje licence je vremenski ograničeno i
                          vrijedi 30 dana od dana plaćanja licence.
                        </p>
                      </v-card-text>
                    </v-sheet>
                    <br />
                    <v-btn icon color="primary" @click="e1 = 1">
                      <sabira_icon
                        icon="slide_sign"
                        :width="28"
                        :height="28"
                        fill="#195391"
                      ></sabira_icon> </v-btn
                    ><v-btn icon color="primary" @click="e1 = 2">
                      <sabira_icon
                        icon="slide_sign"
                        :width="28"
                        :height="28"
                        fill="#195391"
                      ></sabira_icon> </v-btn
                    ><v-btn icon color="primary" @click="e1 = 3">
                      <sabira_icon
                        icon="slide_sign"
                        :width="28"
                        :height="28"
                        fill="#195391"
                      ></sabira_icon>
                    </v-btn>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-col>
            <v-col cols="12" lg="6" xs="12" xl="6">
              <div style="text-align:center;" class="mb-2">
                VIRMANSKO PLAĆANJE - INFO
              </div>
              <v-stepper
                v-model="e2"
                outlined
                flat
                style="background-color:transparent;border-radius: 1.5rem;border:solid 1.5px rgba(51,51,51,0.25) !important;"
              >
                <v-stepper-header>
                  <v-stepper-step :complete="e2 > 1" step="1" color="primary">
                    Virman
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step :complete="e2 > 2" step="2" color="primary">
                    Registracija
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step step="3" color="primary">
                    Aktivacija
                  </v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>
                  <v-stepper-content step="1">
                    <v-sheet
                      class="pa-4 rounded"
                      style="border-radius: 1rem !important;border:solid 1px rgba(51,51,51,0.25) !important;"
                      color="transparent"
                    >
                      <v-card-title style="font-size:1.2rem;opacity:0.75;">
                        Podaci za virmansku uplatu
                      </v-card-title>
                      <v-card-text style="font-size:1.1rem;color: #023047;">
                        <p>
                          Primalac: DSO Webpage.ba<br />
                          Adresa: Mustafe Hukića 7, 75000 Tuzla BiH<br />
                          Trans.rač: 3384402252115588<br />Svrha: SABIRA
                          licenca<br />
                          Iznos: 10 KM
                        </p>
                      </v-card-text>
                    </v-sheet>
                    <br />
                    <v-btn icon color="primary" @click="e2 = 1">
                      <sabira_icon
                        icon="slide_sign"
                        :width="28"
                        :height="28"
                        fill="#195391"
                      ></sabira_icon> </v-btn
                    ><v-btn icon color="primary" @click="e2 = 2">
                      <sabira_icon
                        icon="slide_sign"
                        :width="28"
                        :height="28"
                        fill="#195391"
                      ></sabira_icon> </v-btn
                    ><v-btn icon color="primary" @click="e2 = 3">
                      <sabira_icon
                        icon="slide_sign"
                        :width="28"
                        :height="28"
                        fill="#195391"
                      ></sabira_icon>
                    </v-btn>
                  </v-stepper-content>

                  <v-stepper-content step="2">
                    <v-sheet
                      class="pa-4 rounded"
                      style="border-radius: 1rem !important;border:solid 1px rgba(51,51,51,0.25) !important;"
                      color="transparent"
                    >
                      <v-card-title style="font: size 1.2em;opacity:0.75;">
                        Registracija
                      </v-card-title>
                      <v-card-text style="font-size:1.1rem;color: #023047;">
                        <p>
                          Registrujte se putem ove web stranice koristeći
                          registraciju za besplatnu verziju.<br />Besplatna
                          registracija je dostupna na nekoliko mjesta na ovoj
                          web stranici i možete se registrovati odmah bez obzira
                          na plaćanje.
                        </p>
                        <v-btn
                          @click="open_registration(1)"
                          class="mb-n2 ml-0 mr-0 mt-n2 pa-0"
                          style="text-decoration: underline;font-size:1.1rem;color: #023047;"
                          plain
                          >REGISTRUJ SE OVDJE!</v-btn
                        >
                        <br />
                      </v-card-text>
                    </v-sheet>
                    <br />
                    <v-btn icon color="primary" @click="e2 = 1">
                      <sabira_icon
                        icon="slide_sign"
                        :width="28"
                        :height="28"
                        fill="#195391"
                      ></sabira_icon> </v-btn
                    ><v-btn icon color="primary" @click="e2 = 2">
                      <sabira_icon
                        icon="slide_sign"
                        :width="28"
                        :height="28"
                        fill="#195391"
                      ></sabira_icon> </v-btn
                    ><v-btn icon color="primary" @click="e2 = 3">
                      <sabira_icon
                        icon="slide_sign"
                        :width="28"
                        :height="28"
                        fill="#195391"
                      ></sabira_icon>
                    </v-btn>
                  </v-stepper-content>

                  <v-stepper-content step="3">
                    <v-sheet
                      class="pa-4 rounded"
                      style="border-radius: 1rem !important;border:solid 1px rgba(51,51,51,0.25) !important;"
                      color="transparent"
                    >
                      <v-card-title style="font-size:1.2rem;opacity:0.75;">
                        Aktivacija
                      </v-card-title>
                      <v-card-text style="font-size:1.1rem;color: #023047;">
                        <p>
                          Za aktivaciju korisničkog računa je potrebno najmanje
                          24 sata.<br />
                          Ukoliko ste prilikom registracije unijeli isto ime
                          firme kao i na virmanu prilikom uplate, aktivacija će
                          biti automatska. <br />Ukoliko niste obavjestite nas
                          putem emaila na: info@sabira.ba. Aktivacija će biti
                          manuelna.
                        </p>
                      </v-card-text>
                    </v-sheet>
                    <br />
                    <v-btn icon color="primary" @click="e2 = 1">
                      <sabira_icon
                        icon="slide_sign"
                        :width="28"
                        :height="28"
                        fill="#195391"
                      ></sabira_icon> </v-btn
                    ><v-btn icon color="primary" @click="e2 = 2">
                      <sabira_icon
                        icon="slide_sign"
                        :width="28"
                        :height="28"
                        fill="#195391"
                      ></sabira_icon> </v-btn
                    ><v-btn icon color="primary" @click="e2 = 3">
                      <sabira_icon
                        icon="slide_sign"
                        :width="28"
                        :height="28"
                        fill="#195391"
                      ></sabira_icon>
                    </v-btn>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-col>
          </v-row>
        </v-container>

        <div id="sec"></div>
        <div class="pa-2 pt-0">
          <div style="text-align:left;">
            <div :class="'spacing_' + $vuetify.breakpoint.name">
              <div :class="'headline_' + $vuetify.breakpoint.name">
                Sigurnost.<br />
                Poslovanje bez briga.
              </div>
              <div :class="'subtitle_' + $vuetify.breakpoint.name">
                Poslujte bez brige 365 dana u godini - SABIRA je bazirana na
                najnovijim tehnologijama i sigurnosnim standardima i dostupna
                uvijek i svugdje. Sigurnosni protokoli i zaštite, enkripcije i
                backup-i, renomirano Cloud okruženje i verifikovan sistem
                plaćanja su garancija sigurnog poslovanja.
              </div>
            </div>
          </div>
        </div>

        <v-container fluid class="ma-0 pa-0">
          <v-row>
            <v-col> </v-col>
            <v-col cols="12" lg="6" xs="12" xl="6">
              <v-sheet
                class="pa-4 rounded"
                style="border-radius: 1rem !important;border:solid 1px rgb(108,173,216) !important;"
                color="primary"
              >
                <div :class="'subtitle_' + $vuetify.breakpoint.name">
                  <p style="text-align:center;">
                    <sabira_icon
                      icon="security"
                      :width="160"
                      :height="160"
                      fill="white"
                      class="mt-8 mb-4"
                    />
                  </p>
                  <p style="text-align:center;color:#ffffff;">
                    Dostupnost 24/7/365<br />
                    SSL konekcije korisnika<br />
                    2 X enkripcija pristupa<br />
                    Backup data baza svakih 6 sati<br />
                    Backup platforme 12 X dnevno<br />
                    Renomirano Cloud okruženje<br />
                    UniCredit Bank/Monri plaćanje<br />
                    Zaštita informacija
                  </p>
                </div>
              </v-sheet>
            </v-col>
            <v-col> </v-col>
          </v-row>
        </v-container>

        <div id="faq"></div>
        <div class="pa-2 pt-0">
          <div style="text-align:left;">
            <div :class="'spacing_' + $vuetify.breakpoint.name">
              <div :class="'headline_' + $vuetify.breakpoint.name">
                Uobičajena pitanja.<br />
                Treba da znate sve što je potrebno.
              </div>
              <div :class="'subtitle_' + $vuetify.breakpoint.name">
                U ovoj sekciji će te pronaći odgovore na uobičajena pitanja. Za
                dodatne informacije molimo da nam se javite, rado ćemo Vam
                pomoći.
              </div>
            </div>
          </div>
        </div>

        <v-container fluid class="ma-0 pa-0">
          <v-row>
            <v-col cols="12" lg="6" xs="12" xl="6">
              <v-sheet
                class="pa-4 rounded"
                style="border-radius: 1rem !important;border:solid 1.5px rgba(51,51,51,0.25) !important;"
                color="transparent"
              >
                <v-expansion-panels flat accordion hover>
                  <v-expansion-panel v-for="(item, i) in items" :key="i">
                    <v-expansion-panel-header
                      style="font-size:1.2rem;color: #023047;"
                      color="#f0f0f0"
                      >{{ item.header
                      }}<template v-slot:actions>
                        <v-icon color="primary">
                          $expand
                        </v-icon>
                      </template></v-expansion-panel-header
                    >
                    <v-expansion-panel-content
                      class="primary--text"
                      style="font-size: 1.1rem; color: #023047;"
                      color="#f0f0f0"
                    >
                      {{ item.content }}
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-sheet>
            </v-col>
            <v-col
              style="display:flex;justify-content: center;align-items: center;"
            >
              <p style="text-align:center;font-size:1.2rem;color: #023047;">
                <sabira_icon
                  icon="hacker"
                  :width="120"
                  :height="120"
                /><br /><br />
                Uputstvo<br />
                Integrisana podrška
                <br /><br />
                info@sabira.ba<br />
                +387 62 016 016<br />
                <v-btn
                  icon
                  href="https://www.facebook.com/sabiraposlovanje"
                  target="_new"
                  class="ma-4"
                  x-large
                >
                  <sabira_icon icon="logo-facebook"></sabira_icon>
                </v-btn>
                <v-btn
                  icon
                  href="https://m.me/sabiraposlovanje"
                  target="_new"
                  class="ma-4"
                  x-large
                >
                  <sabira_icon icon="logo-messenger" fill="grey"></sabira_icon>
                </v-btn>
              </p>
            </v-col>
          </v-row>
        </v-container>

        <div id="video"></div>
        <div class="pa-2 pt-0">
          <div style="text-align:left;">
            <div :class="'spacing_' + $vuetify.breakpoint.name">
              <div :class="'headline_' + $vuetify.breakpoint.name">
                Video.<br />
                SABIRA promo.
              </div>
              <div :class="'subtitle_' + $vuetify.breakpoint.name">
                Informišite se brzo i jednostavno! Pogledajte video!
              </div>
            </div>
          </div>
        </div>

        <v-container fluid class="ma-0 pa-0">
          <v-sheet
            class="pa-4 rounded"
            style="border-radius: 1rem !important;border:solid 1.5px rgba(51,51,51,0.25) !important;display:flex;justify-content: center;align-items: center;"
            color="transparent"
          >
            <iframe
              :class="'video_' + $vuetify.breakpoint.name"
              :src="getYouTubeEmbedUrl(yourVideoId)"
              frameborder="0"
              allowfullscreen
            ></iframe>
          </v-sheet>
        </v-container>
      </div>

      <v-container class="ma-6"></v-container>

      <v-dialog v-model="show_registration" persistent scrollable width="50rem">
        <v-card v-if="$vuetify.breakpoint.mobile">
          <v-card-text>
            <div
              v-if="$vuetify.breakpoint.mobile"
              class="mx-auto mt-4"
              style="display:grid;align-items:center;justify-items:center;grid-row-gap:3rem;"
            >
              <sabira_icon icon="hacker" :width="70" :height="70" />
              <span class="title" style="text-align:center;">
                SABIRA je trenutno dostupna za korištenje isključivo putem
                laptop i desktop uređaja.</span
              >
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn plain @click="show_registration = false">{{
              $t("close")
            }}</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
        <v-card scrollable v-else>
          <v-toolbar flat dark color="primary white--text">
            <img :src="logoSrcWhite" height="100%" class="pa-2 mr-2" />
            <v-toolbar-title>U samo par koraka do SABIRA</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn plain @click="show_registration = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>
          <v-card-text class="pa-0 ma-0" style="height:38rem;">
            <v-stepper flat v-model="e6" vertical>
              <v-stepper-step :complete="e6 > 1" step="1">
                Registracija
                <small>Unesite korisničke podatke za pristupanje SABIRA</small>
              </v-stepper-step>
              <v-stepper-content step="1">
                <div
                  style="display:grid;grid-template-columns: 1fr 1fr;grid-column-gap:1rem;grid-row-gap: 1rem;"
                  class="pt-2 pb-2"
                >
                  <v-text-field
                    label="Ime i prezime"
                    hide-details
                    persistent-placeholder
                    v-model="user.name"
                    outlined
                  ></v-text-field>
                  <v-text-field
                    label="Email adresa"
                    hide-details
                    persistent-placeholder
                    v-model="user.email"
                    outlined
                    @blur="email_check()"
                  ></v-text-field>
                  <v-text-field
                    label="Korisničko ime"
                    hide-details
                    persistent-placeholder
                    v-model="user.username"
                    outlined
                    @blur="username_check()"
                  ></v-text-field>
                  <v-text-field
                    label="Lozinka"
                    hide-details
                    persistent-placeholder
                    v-model="user.password"
                    outlined
                    type="password"
                  ></v-text-field>
                  <v-text-field
                    label="Adresa"
                    hide-details
                    persistent-placeholder
                    v-model="user.address"
                    outlined
                  ></v-text-field>
                  <v-text-field
                    label="Postanski broj"
                    hide-details
                    persistent-placeholder
                    v-model="user.zip"
                    outlined
                    maxlength="6"
                  ></v-text-field>
                  <v-text-field
                    label="Grad"
                    hide-details
                    persistent-placeholder
                    v-model="user.city"
                    outlined
                  ></v-text-field>
                  <v-text-field
                    label="Telefon"
                    hide-details
                    persistent-placeholder
                    v-model="user.phone"
                    outlined
                  ></v-text-field>
                </div>
                <div class="mt-4">
                  <v-btn
                    color="primary"
                    left
                    :disabled="user.username_exists || user.email_exists"
                    @click="e6 = 2"
                  >
                    Nastavi
                  </v-btn>
                </div>
              </v-stepper-content>

              <v-stepper-step :complete="e6 > 2" step="2">
                Podaci o firmi
                <small>Unesite osnovne podatke o Vašoj firmi</small>
              </v-stepper-step>

              <v-stepper-content step="2">
                <div
                  style="display:grid;grid-template-columns: 1fr 1fr;grid-column-gap:1rem;grid-row-gap: 1rem;"
                  class="pt-2 pb-2"
                >
                  <v-text-field
                    label="Naziv firme"
                    hide-details
                    persistent-placeholder
                    v-model="user.company_name"
                    outlined
                  ></v-text-field>
                  <v-text-field
                    label="ID Broj"
                    hide-details
                    persistent-placeholder
                    v-model="user.id_number"
                    @blur="company_check()"
                    outlined
                  ></v-text-field>
                  <v-text-field
                    label="PDV Broj (0 ako nije PDV obveznik)"
                    hide-details
                    persistent-placeholder
                    v-model="user.vat_number"
                    outlined
                  ></v-text-field>
                </div>
                <div class="mt-4">
                  <v-btn
                    color="primary"
                    left
                    :disabled="user.company_exists"
                    @click="generate_payment_form()"
                  >
                    Nastavi
                  </v-btn>
                  <v-btn text @click="e6 = 1">
                    Nazad
                  </v-btn>
                </div>
              </v-stepper-content>

              <v-stepper-step
                v-if="registration_type == 2"
                :complete="e6 > 3"
                step="3"
              >
                Uplata i aktivacija usluge
              </v-stepper-step>

              <v-stepper-content step="3" v-if="registration_type == 2">
                <v-card flat>
                  <!-- <div
                    style="display:grid;grid-template-columns: repeat(5,1fr);grid-column-gap:1rem;width:50%;"
                  >
                    <img height="30rem" :src="logoMC" />
                    <img
                      height="30rem"
                      src="@/assets/images/ms_vrt_opt_pos_73_3x.png"
                    />
                    <img
                      height="30rem"
                      src="@/assets/images/Visa 2015 50.gif"
                    />
                  </div> -->
                  <v-skeleton-loader
                    v-if="payment_loading"
                    type="card"
                  ></v-skeleton-loader>

                  <v-radio-group
                    label="Vrsta usluge"
                    item-text="name"
                    :items="payment_options"
                    v-model="selected_payment_option"
                    outlined
                    hide-details
                    return-object
                  >
                    <v-radio
                      v-for="(n, index) in payment_options"
                      :key="'payment_option_' + index"
                      :label="n.name"
                      :value="n"
                      row
                    ></v-radio>
                  </v-radio-group>
                  <div id="card-errors"></div>
                  <div id="card-element" style="margin-top: 2rem;">
                    <!-- A Monri Component will be inserted here. -->
                  </div>
                </v-card>
                <v-btn
                  :loading="is_btn_loading"
                  color="primary"
                  class="mr-2"
                  @click="send_for_payment()"
                >
                  Nastavi
                </v-btn>
                <v-btn text @click="e6 = 2">
                  Nazad
                </v-btn>
              </v-stepper-content>
            </v-stepper>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="show_contact_us" width="40rem" persistent scrollable>
        <v-card>
          <v-toolbar dark color="primary" flat>
            <sabira_icon
              icon="email_invoice"
              class="mr-2"
              :strokewidth="3"
              fill="white"
            />
            <v-toolbar-title class="ml-1">
              Kontakt forma
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pa-4">
            <div style="display:grid;grid-row-gap:1rem;">
              <v-text-field
                outlined
                persistent-placeholder
                placeholder="Unesite naziv firme"
                label="Naziv firme"
                hide-details
                v-model="contact.company_name"
              ></v-text-field>
              <v-text-field
                outlined
                persistent-placeholder
                placeholder="ID/PDV broj"
                label="ID ili PDV broj firme"
                hide-details
                v-model="contact.id_number"
              ></v-text-field>
              <v-text-field
                outlined
                hide-details
                persistent-placeholder
                placeholder="Unesite željeni broj licenci/korisnika"
                label="Broj licenci"
                v-model="contact.number_of_licenses"
              ></v-text-field>
              <v-text-field
                outlined
                hide-details
                persistent-placeholder
                placeholder="Kontakt osoba"
                label="Ime i prezime kontakt osobe"
                v-model="contact.contact_name"
              ></v-text-field>
              <v-text-field
                outlined
                hide-details
                persistent-placeholder
                placeholder="Email adresa"
                label="Email adresa kontakt osobe"
                v-model="contact.contact_email"
              ></v-text-field>
              <v-text-field
                outlined
                hide-details
                persistent-placeholder
                placeholder="Telefon"
                label="Telefonski broj kontakt osobe"
                v-model="contact.contact_phone"
              ></v-text-field>
              <v-textarea
                label="Poruka"
                placeholder="Dodante informacije"
                persistent-placeholder
                outlined
                hide-details
                v-model="contact.message"
              >
              </v-textarea>
            </div>
          </v-card-text>
          <v-card-actions class="background">
            <v-btn text depressed @click="show_contact_us = false"
              >Odustani</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              text
              depressed
              :loading="is_sending_message"
              @click="send_contact_us()"
              >Pošalji</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="show_payment_safety"
        width="50rem"
        persistent
        scrollable
      >
        <v-card>
          <v-toolbar dark flat color="primary">
            <sabira_icon
              icon="info"
              class="mr-3"
              :strokewidth="3"
              fill="white"
            />
            <v-toolbar-title ml-1
              >Sigurnost plaćanja kreditnim karticama</v-toolbar-title
            >
          </v-toolbar>
          <v-card-text class="pt-4">
            <span v-html="payment_safety_text"></span>
          </v-card-text>
          <v-card-actions class="background">
            <v-btn text depressed @click="show_payment_safety = false"
              >Zatvori</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="show_privacy" width="50rem" persistent scrollable>
        <v-card>
          <v-toolbar dark flat color="primary">
            <sabira_icon
              icon="info"
              class="mr-3"
              :strokewidth="3"
              fill="white"
            />
            <v-toolbar-title ml-1>Zaštita privatnosti</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pt-4">
            <span v-html="privacy_text"></span>
          </v-card-text>
          <v-card-actions class="background">
            <v-btn text depressed @click="show_privacy = false">Zatvori</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="show_ios_privacy" width="50rem" persistent scrollable>
        <v-card>
          <v-toolbar dark flat color="primary">
            <sabira_icon
              icon="info"
              class="mr-3"
              :strokewidth="3"
              fill="white"
            />
            <v-toolbar-title ml-1
              >Zaštita privatnosti - iOS Aplikacija</v-toolbar-title
            >
          </v-toolbar>
          <v-card-text class="pt-4">
            <span v-html="ios_privacy_text"></span>
          </v-card-text>
          <v-card-actions class="background">
            <v-btn text depressed @click="show_ios_privacy = false"
              >Zatvori</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="show_purchase_terms"
        width="50rem"
        persistent
        scrollable
      >
        <v-card>
          <v-toolbar dark flat color="primary">
            <sabira_icon
              icon="info"
              class="mr-3"
              :strokewidth="3"
              fill="white"
            />
            <v-toolbar-title ml-1>Uslovi kupovine</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pt-4">
            <span v-html="purchase_terms"></span>
          </v-card-text>
          <v-card-actions class="background">
            <v-btn text depressed @click="show_purchase_terms = false"
              >Zatvori</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <v-container
      fluid
      absolute
      style="background-color: #0a213a;"
      class="pa-12"
    >
      <v-row>
        <v-col
          cols="12"
          lg="3"
          sm="12"
          md="3"
          xs="12"
          style="text-align:center;"
        >
          <img :src="logoSrc" style="max-width:120px;" class="mx-auto" />
        </v-col>
        <v-col cols="12" sm="4" lg="3" md="3" xs="4">
          <div style="text-align:left; opacity: 0.75;" class="white--text">
            DSO Webpage.ba<br />
            Mustafe Hukića 7<br />
            75000 Tuzla<br />
            Bosna i Hercegovina<br /><br />
            ID: 4310820720001<br />
            Broj rješenja: 04-17-1478/23-MP, Tuzla<br />
            D-U-N-S: 67-222-8818
          </div>
        </v-col>
        <v-col cols="12" lg="3" md="3" sm="4" xs="12">
          <div style="text-align:left; opacity: 0.75;" class="white--text">
            <div>
              <a
                @click="show_payment_safety = true"
                style="text-decoration: underline;color: #fff;"
                >Sigurnost plaćanja kreditnim karticama</a
              >
            </div>
            <br />
            <div>
              <a
                @click="show_privacy = true"
                style="text-decoration: underline;color: #fff;"
                >Zaštita privatnosti</a
              >
            </div>
            <br />
            <div>
              <a
                @click="show_ios_privacy = true"
                style="text-decoration: underline;color: #fff;"
                >Zaštita privatnosti - iOS Aplikacija</a
              >
            </div>
            <br />
            <div class="mb-2">
              <a
                @click="show_purchase_terms = true"
                style="text-decoration: underline;color: #fff;"
                >Uslovi kupovine</a
              >
            </div>
            <br />
            info@sabira.ba<br />
            +387 62 016 016
          </div>
        </v-col>
        <v-col cols="12" lg="3" md="3" sm="4" xs="12">
          <img
            @click="
              open_link(
                'https://www.mastercard.ba/bs-ba/korisnici/podrska/sigurnost-i-zastita/identity-check.html'
              )
            "
            :src="mcIdCheck"
            width="70"
            class="mr-6"
          />
          <img
            @click="open_link('https://usa.visa.com/products/visa-secure.html')"
            :src="visaSecure"
            width="70"
            class="ml-6"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col class="text-center" cols="12">
          <div :class="'mx-auto mt-6 footer_' + $vuetify.breakpoint.name">
            <div
              style="text-align:center;display:grid;grid-column-gap:1rem;grid-template-columns: repeat(5,max-content);align-items:center;justify-content:center;padding:0.25rem;"
            >
              <img
                @click="open_link('https://monri.com')"
                :src="payWeb"
                class="ml-2 mr-2 footer_image"
              />
              <img
                @click="open_link('https://monri.com')"
                :src="monriBadge"
                class="ml-2 mr-2 footer_image"
              />
              <img
                @click="open_link('https://www.mastercard.ba/bs-ba.html')"
                :src="mcAcc"
                class="ml-2 mr-2 footer_image"
              />
              <img
                @click="
                  open_link(
                    'https://brand.mastercard.com/brandcenter/more-about-our-brands.html'
                  )
                "
                :src="msAcc"
                class="ml-2 mr-2 footer_image"
              />
              <img
                @click="open_link('https://visaeurope.com')"
                :src="visaV"
                class="ml-2 mr-2 footer_image"
              />
            </div>
          </div>
        </v-col>
      </v-row>

      <v-row class="pt-6">
        <v-col cols="12">
          <div class="text-center white--text" style="opacity:0.5;">
            © 2015 - {{ new Date().getFullYear() }} <strong>SABIRA™</strong>.
            Sva prava zadržana.
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// import imageAm from "@/assets/images/sabira_am.png";
import logoMc from "@/assets/images/mc_vrt_opt_pos_73_3x.png";
import sabiraIos from "@/assets/images/sabira_ios.png";
import logoSrc from "@/assets/images/sabira_logo_full.svg";
import logoSrcWhite from "@/assets/images/sabira_logo_full_white.svg";
import mcIdCheck from "@/assets/images/mc_idcheck_vrt_rgb_rev.png";
import visaSecure from "@/assets/images/visa-secure_blu_72dpi.jpg";
import payWeb from "@/assets/images/payweb.png";
import monriBadge from "@/assets/images/monri_badge.png";
import mcAcc from "@/assets/images/mc_acc_opt_70_3x.png";
import msAcc from "@/assets/images/ms_acc_opt_70_3x.png";
import visaV from "@/assets/images/Visa 2015 50.gif";
/* eslint-disable */
var monri = Monri("157fa872f1a6f7e3d7e0f4305a99028644bc82da", {
  locale: "hr",
});
/* eslint-enable */
var card = null;
import VueCompareImage from "vue-compare-image";
export default {
  components: {
    VueCompareImage,
  },
  data() {
    return {
      logoMc,
      imageAm: "https://sabira.ba/img/sabira_am.png",
      sabiraIos,
      logoSrc,
      logoSrcWhite,
      mcIdCheck,
      visaSecure,
      payWeb,
      monriBadge,
      mcAcc,
      msAcc,
      visaV,
      yourVideoId: "97-cjnBkaWo?si=M_2Fh4vEQaUO4QrP",
      items: [
        {
          header: "Šta dobijam u Besplatnoj verziji?",
          content:
            "U Besplatnoj verziji korisnik ima zagarantovani pristup svim opcijama izuzev broja faktura koje su ograničene na 3 tokom jednog mjeseca.",
        },
        {
          header: "Šta dobijam u Profesionalnoj veziji?",
          content:
            "U Profesionalnoj verziji korisnik ima zagarantovani pristup svim opcijama bez ograničenja tokom jednog mjeseca.",
        },
        {
          header: "Za koliko korisnika važi uplata jedne licence?",
          content:
            "Uplata jedne licence važi za jednog korisnika. Jedna firma može sadržavati više licenci, tj. više korisnika.",
        },
        {
          header: "Šta predstavlja Korporativna licenca?",
          content:
            "Korporativna licenca predstavlja licencu koja se kupuje za više korisnika. Jedna firma u okviru Korporativne licence može sadržavati više korisnika (primjer: 5, 10, 15...itd.).",
        },
        {
          header: "Koliko važi jedna licenca, tj. jedna uplata?",
          content:
            "Ukoliko je uplata izvršena za jednu licencu za mjesec dana, ta licenca vrijedi mjesec dana. Korisnik ima zagarantovan neograničen pristup svim opcijama i funkcionalnostima u okviru mjesec dana. VAŽNO: trajanje licence je vremenski ograničeno i vrijedi 30 dana od dana plaćanja licence. Za uplate putem virmana trajanje licence je 30 dana od dana evidentiranja uplate.",
        },
        {
          header: "Koliko dugo će Besplatna licenca biti besplatna?",
          content:
            "Besplatna licenca trenutno nema rok trajanja. Korisnik može koristiti besplatnu licencu koliko god želi. Bilo kakve promjene po ovom pitanju bit će unaprijed najavljene prema svim korisnicima.",
        },
        {
          header: "Da li je kartično plaćanje putem ove web stranice sigurno?",
          content:
            "Kartično plaćanje putem ove web stranice je sigurno. Koristimo najnaprednije sigurnosne standarde i tehnologije. Sve transakcije se vrše putem Monri Payments i UniCredit Bank Bosna i Hercegovina. Monri je jedan od najsigurnijih i najboljih servisa za kartično plaćanje u regiji. Više informacija o Monri Payments servisu možete pronaći na njihovoj web stranici.",
        },
        {
          header: "Da li je jednostavno korisiti SABIRA?",
          content:
            "Naravno, jednostavno je. Korištenje cijele platforme je intuitivno i od korisnika ne zahtjeva nikakvo prethodno znanje. Dodatno, integrisana sistemska obavještenja Vas cijelo vrijeme informišu o specifičnim koracima ili procesima koji su u toku.",
        },
        {
          header: "Šta ako imam problem koji ne mogu da riješim?",
          content:
            "U sklopu platforme nalazi se Korisničko uputstvo sa detaljima o svim funkcionalnostima i opcijama. Ukoliko imate problem koji ne možete sami da riješite, možete potražiti rješenje u uputstvu. Dodatno, možete nas kontaktirati putem SABIRA integrisanog sistema Podrške. Rado ćemo Vam pomoći.",
        },
        {
          header: "Šta ako ne koristim registrovanu besplatnu verziju?",
          content:
            "Ukoliko ne koristite registrovanu SABIRA besplatnu verziju u periodu od pet mjeseci sistem će Vas obavijestiti o tome. Nakon isteka šestog mjeseca sistem će automatski deaktivirati korisnika.",
        },
        {
          header: "Šta ako želim da deaktiviram ili obrišem korisnički račun?",
          content:
            "U postavkama imate dvije mogućnosti. Jedna mogućnost je da u okviru korisničkih postavki deaktivirate korisnički pristup, deaktivacija korisnika u periodu od 90 dana. Druga mogućnost je da u okviru postavki firme jednim klikom izbrišete sve korisničke podatke i sve podatke vaše firme. Mi ne zadržavamo vaše podatke nakon brisanja računa firme.",
        },
        {
          header:
            "Da li se mogu registrovati i koristiti SABIRA kao fizičko lice?",
          content:
            "SABIRA je namijenjena isključivo pravnim licima. Fizička lica se ne mogu registrovati i ne mogu koristiti SABIRA obzirom da su sve funkcionalnosti usklađene za poslovanje pravnih subjekata u odnosu na zakonske regulative.",
        },
      ],
      e1: 1,
      e2: 1,
      is_sending_message: false,
      contact: {
        company_name: null,
        number_of_licenses: null,
        message: null,
        contact_name: null,
        contact_email: null,
        contact_phone: null,
      },
      show_contact_us: false,
      selected_payment_option: null,
      privacy_text:
        "<p class='mt-4'>Obavezujemo se pružati zaštitu osobnim podacima kupaca na način da prikupljamo samo nužne, osnovne podatke o kupcima / korisnicima koji su nužni za ispunjenje naših obveza; informiramo kupce o načinu korištenja prikupljenih podataka, redovito dajemo kupcima mogućnost izbora o upotrebi njihovih podataka, uključujući mogućnost odluke žele li ili ne da se njihovo ime ukloni s lista koje se koriste za marketinške kampanje.</p><p class='mt-4'>Svi se podaci o korisnicima strogo čuvaju i dostupni su samo uposlenicima kojima su ti podaci nužni za obavljanje posla. Svi naši uposlenici i poslovni partneri odgovorni su za poštivanje načela zaštite privatnosti.</p>",
      payment_safety_text:
        "<p class='mt-4'>Tajnost Vaših podataka je zaštićena i osigurana korištenjem posljednje verzije TLS enkripcije. Stranice za naplatu putem interneta osigurane su korištenjem Secure Socket Layer (SSL) protokola sa 128-bitnom enkripcijom podataka. SSL enkripcija je postupak šifriranja podataka radi sprječavanja neovlaštenog pristupa prilikom njihovog prijenosa.</p><p class='mt-4'>Time je omogućen siguran prijenos informacija te onemogućen nedozvoljen pristup podacima prilikom komunikacije između korisnikovog računala i WebPay servisa, te obratno. WebPay servis i financijske ustanove razmjenjuju podatke uporabom virtualne privatne mreže (VPN), koja je zaštićena od neautoriziranog pristupa. Monri Payment Gateway je certificiran prema PCI DSS Level 1 sigurnosnom standardu propisanom Visa i Mastercard pravilima.</p><p class='mt-4'>WebPay servis i financijske ustanove razmjenjuju podatke uporabom virtualne privatne mreže (VPN), koja je zaštićena od neautoriziranog pristupa. Monri Payment Gateway je certificiran prema PCI DSS Level 1 sigurnosnom standardu propisanom Visa i Mastercard pravilima.</p><p class='mt-4'>Monri Payment Gateway je certificiran prema PCI DSS Level 1 sigurnosnom standardu propisanom Visa i Mastercard pravilima.</p><p class='mt-4'>DSO Webpage.ba ne pohranjuje brojeve kreditnih kartica i brojevi nisu dostupni neovlaštenim osobama.</p>",
      purchase_terms:
        "<p class='mt-4'>Ovim se uslovima utvrđuje postupak naručivanja, plaćanja, isporuke te reklamacija proizvoda koji su ponuđeni na ovim stranicama.</p><p class='mt-4'>Prodavac je DSO Webpage.ba, a kupac je posjetitelj ovih stranica koji popuni elektronsku narudžbu, pošalje je elektronski prodavcu te izvrši plaćanje putem kreditnih kartica, ili pouzećem.</p><p class='mt-4'>NARUČIVANJE - Kupac naručuje artikal, usluge ili proizvode putem elektronskog obrasca narudžbe. Kupcem se smatra svaka osoba koja elektronski naruči barem jedan proizvod, popuni tražene podatke i pošalje narudžbu. Sve cijene izražene su u konvertibilnim markama, cijene su konačne, tj. one koje kupac plača (porez je uračunat). Artikal, usluge ili proizvodi smatra naručenim u trenutku kada kupac potvrdi plaćanje.</p><p class='mt-4'>PLAĆANJE - Naručeni artikli, proizvodi ili usluge plaćaju se online jednom od kreditnih kartica: MasterCard® i Maestro® ili Visa.</p><p class='mt-4'>ISPORUKA - Kupcu se artiki, proizvodi ili usluge, isporučuju elektronski tj. dozvolom pristupa na “SABIRA”, a prodavac se obvezuje poslati obavijest isključivo u obliku elektronske pošte kupcu o mogućnosti korištenja “SABIRA”. Nakon primitka elektronske pošte kupac može odmah pristupiti poslovnom rješenju SABIRA.</p><p class='mt-4'>REKLAMACIJE - Prodavac se obvezuje isporučiti artikal, proizvod ili usluge koji su tehnički ispravni te odgovaraju opisu proizvoda navedenom na https://sabira.ba. Slika koja ilustrira proizvod na Internet stranici ne mora odgovarati stvarnom izgledu proizvoda te kupac ne može reklamirati ovaj segment.</p><p class='mt-4'>U slučaju tehničke neispravnosti, kupac je dužan reklamirati proizvod u roku od 4 (četiri) radna dana.</p><p class='mt-4'>U slučaju gore navedenog kupac nema pravo tražiti povrat novca, već isključivo aktivaciju korisničke usluge.</p><p class='mt-4'>U slučaju da preuzimanje linkova, Ili download nije moguće obaviti zbog tehničkih problema uzrokovanih na serveru prodavca, prodavac se obvezuje poslati elektronsku poštu sa novom mogućnosti za pristup za što kupac ne snosi nikakve troškove. U slučaju da kupac niti tada ne bude u stanju obaviti download koji je uzrokovan zbog tehničkih problema na serveru prodavca, kupac je dužan o tome kontaktirati prodajnu službu prodavca koja će ponuditi adekvatno rješenje koje u sebi neće sadržavati nikakvu naknadu i daljnje troškove od strane kupca. Kupac nema pravo tražiti povrat novca u ovoj situaciji. U slučaju da kupac ne može preuzeti proizvod putem download-a ili pristupa, a tehnički problemi nisu vezani za prodavca, već su uzrokovani od strane kupca, operatera ili treće osobe prodavac ne snosi nikakvu odgovornost I nije dužan kupcu omogućiti download, ili pristup.</p>",
      ios_privacy_text:
        "<p class='mt-4'>SABIRA iOS aplikacija prikuplja samo podatke koji su neophodni za funkcionisanje aplikacije i pružanje usluga. Ovo uključuje osnovne podatke o vašem poslovanju, kao što su informacije o Vama kao korisniku, o artiklima, klijentima, fakturama i transakcijama, ponudama.</p><p class='mt-4'>Vaši podaci se koriste isključivo za funkcionisanje aplikacije. Ne dijelimo vaše podatke sa trećim stranama.</p><p class='mt-4'>Koristimo najnovije sigurnosne protokole za zaštitu vaših podataka.</p><p class='mt-4'>Imate pravo da uvijek zatražite uvid u vaše podatke, njihovu izmjenu ili brisanje. Izmjenu i brisanje podataka možete izvršiti i vlastoručno putem SABIRA web platforme (https://sabira.ba). Također možete zatražiti izvoz vaših podataka u jednom od standardnih formata.</p><p class='mt-4'>Za sva pitanja vezana za privatnost podataka, možete nas kontaktirati putem email adrese: info@sabira.ba</p>",
      show_payment_safety: false,
      show_privacy: false,
      show_ios_privacy: false,
      show_purchase_terms: false,
      is_btn_loading: false,
      show_registration: false,
      payment_loading: false,
      registration_type: 1,
      payment_options: [
        {
          amount: 10,
          name: "10 KM za tekući mjesec",
          months: 1,
          discount: 0,
        },
        {
          amount: 10,
          name: "54 KM za narednih 6 mjeseci (10% popusta)",
          months: 6,
          discount: 10,
        },
        {
          amount: 10,
          name: "102 KM za narednih 12 mjeseci (15% popusta)",
          months: 12,
          discount: 15,
        },
      ],
      user: {
        id: 0,
        name: null,
        email: null,
        username: null,
        password: null,
        address: null,
        city: null,
        country: null,
        phone: null,
        id_number: null,
        vat_number: null,
        username_exists: false,
        company_exists: false,
        account_id: null,
        active_date: null,
        active: true,
        payment: null,
      },
      e6: 1,
    };
  },
  watch: {
    registration_type: {
      handler() {
        this.e6 = 1;
      },
      immediate: true,
    },
    selected_payment_option: {
      handler() {
        this.generate_payment_form();
      },
      immediate: false,
    },
  },
  methods: {
    getYouTubeEmbedUrl(videoId) {
      return `https://www.youtube.com/embed/${videoId}`;
    },
    headline_spacing() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "pa-0 mt-8";
        case "sm":
          return "color: green";
        case "md":
          return "color: blue;font-size: 3rem;line-height: 110%;";
        case "lg":
          return "pa-16";
        case "xl":
          return "color: yellow";
      }
    },
    center_style() {
      if (this.$vuetify.breakpoint.mobile) {
        return "grid-template-columns:max-content repeat(3,1fr) max-content;text-align:center;grid-column-gap:0rem;";
      } else {
        return "";
      }
    },
    validate2() {
      return new Promise((resolve, reject) => {
        var has_errors = false;
        if (
          this.contact.company_name == null ||
          this.contact.company_name.length == 0
        ) {
          has_errors = true;
          reject("Molimo unesite naziv firme.");
        }
        if (
          this.contact.contact_name == null ||
          this.contact.contact_name.length == 0
        ) {
          has_errors = true;
          reject("Molimo unesite ime i prezime kontakt osobe.");
        }
        if (
          this.contact.contact_email == null ||
          this.contact.contact_email.length == 0 ||
          !this.contact.contact_email.match(
            /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
          )
        ) {
          has_errors = true;
          reject("Molimo unesite ispravnu email adresu.");
        }
        if (
          this.contact.contact_phone == null ||
          this.contact.contact_phone.length == 0 ||
          !this.contact.contact_phone.match(
            /^\+?[0-9]{3,4}[0-9]{3,4}[0-9]{3,4}$/
          )
        ) {
          has_errors = true;
          reject("Molimo unesite ispravan telefonski broj.");
        }
        if (!has_errors) {
          resolve();
        }
      });
    },
    send_contact_us() {
      this.validate2()
        .then(() => {
          this.is_sending_message = true;
          var full_message = "";
          full_message +=
            "Naziv firme: " + this.contact.company_name + "<br />";
          full_message += "ID Broj: " + this.contact.id_number + "<br />";
          full_message +=
            "Broj licenci: " + this.contact.number_of_licenses + "<br />";
          full_message +=
            "Kontakt osoba: " + this.contact.contact_name + "<br />";
          full_message +=
            "Email adresa: " + this.contact.contact_email + "<br />";
          full_message += "Tel: " + this.contact.contact_phone + "<br />";
          full_message += "Poruka: <br /> " + this.contact.message + "<br />";

          var message = {
            subject: "Enterprise forma",
            recipients: [{ name: "sabira.ba", email: "info@sabira.ba" }],
            message: full_message,
            sender: { name: "SABIRA B2C Portal", email: "info@sabira.ba" },
            template: "sabira",
            attachments: [],
            account_logo: null,
          };

          this.$http({
            method: "POST",
            url: process.env.VUE_BASE_MAILER_URL,
            data: message,
          }).then((resp) => {
            if (resp.status == 200) {
              this.$webpageEventBus.$emit("show_status", {
                type: "success",
                message: "Poruka uspješno poslana.",
                timeout: 4000,
              });
              this.is_sending_message = false;
              this.show_contact_us = false;
            } else {
              this.$webpageEventBus.$emit("show_status", {
                type: "error",
                message: "Greška prilikom slanja poruke",
                timeout: 2000,
              });
              this.is_sending_message = false;
            }
          });
        })
        .catch((error) => {
          this.$webpageEventBus.$emit("show_status", {
            type: "error",
            message: error,
            timeout: 2000,
          });
        });
    },
    contact_us() {
      this.show_contact_us = true;
    },
    send_enterprise_mail() {
      var message = {
        template: "sabira",
        subject: "Dobro došli na SABIRA",
        recipients: [],
        sender: null,
        attachments: [],
        message: null,
        account_logo: null,
      };
      message.sender = {
        name: "SABIRA",
        email: "mailer@sabira.ba",
      };
      message.recipients.push({
        name: this.user.name,
        email: this.user.email,
      });
      message.message =
        "Poštovana(ni) " +
        this.user.name +
        ", registracija na SABIRA je uspješno kompletirana. Od sada možete koristiti svoje korisničko ime i lozinku za prijavu na SABIRA.<br><br>Kontaktirat ćemo Vas povodom dogovora za SABIRA Korporativnu verziju.<br><br>Želimo Vam uspješno poslovanje!";
      this.$http({
        method: "POST",
        url: "https://sabira.ba/mailer",
        data: message,
      }).catch((e) => {
        this.$webpageEventBus.$emit("show_status", {
          type: "error",
          message: e.message,
          timeout: 4000,
        });
      });
    },
    send_welcome_email() {
      var message = {
        template: "sabira",
        subject: "Dobro došli na SABIRA",
        recipients: [],
        sender: null,
        attachments: [],
        message: null,
        account_logo: null,
      };
      message.sender = {
        name: "SABIRA",
        email: "mailer@sabira.ba",
      };
      message.recipients.push({
        name: this.user.name,
        email: this.user.email,
      });
      message.message =
        "Poštovana(ni) " +
        this.user.name +
        ", registracija na SABIRA je uspješno kompletirana. Od sada možete koristiti svoje korisničko ime i lozinku za prijavu na SABIRA.<br><br>Želimo Vam uspješno poslovanje!";
      this.$http({
        method: "POST",
        url: process.env.VUE_BASE_MAILER_URL,
        data: message,
      }).catch((e) => {
        this.$webpageEventBus.$emit("show_status", {
          type: "error",
          message: e.message,
          timeout: 4000,
        });
      });
    },
    get_invoice(invoice_id) {
      return this.$http({
        method: "POST",
        url: "/fakture/get_by_id",
        data: {
          id: invoice_id,
          account_id: this.$store.getters.user.account_id,
        },
      });
    },
    send_payment_email(invoice) {
      return new Promise((resolve, reject) => {
        try {
          let calculatedAmount =
            this.selected_payment_option.amount *
            this.selected_payment_option.months;
          calculatedAmount =
            calculatedAmount -
            (calculatedAmount * this.selected_payment_option.discount) / 100;
          var message = {
            template: "sabira",
            subject: "Hvala na izvršenoj uplati " + invoice.broj,
            recipients: [],
            sender: null,
            attachments: [],
            message: null,
            account_logo: null,
          };

          this.$helpers
            .generate_invoice_pdf(invoice, true, true, null)
            .then((resp) => {
              var invoice_pdf = resp;
              message.attachments.push({
                filename: "faktura_" + invoice.broj + ".pdf",
                content: invoice_pdf.content,
                encoding: "binary",
              });
              message.sender = {
                name: "SABIRA",
                email: "mailer@sabira.ba",
              };
              message.recipients.push({
                name: this.user.name,
                email: this.user.email,
              });
              message.message =
                "Poštovana(ni) " +
                this.user.name +
                ", ovim putem Vas želimo obavjestiti da smo primili vašu uplatu u iznosu od " +
                calculatedAmount +
                " KM.";
              this.$http({
                method: "POST",
                url: process.env.VUE_BASE_MAILER_URL,
                data: message,
              })
                .then(() => {
                  resolve();
                })
                .catch((email_ex) => {
                  reject(email_ex);
                });
            })
            .catch((t) => {
              reject(t);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    login_user() {
      this.$http({
        method: "POST",
        url: "/auth/login",
        withCredentials: false,
        data: {
          username: this.user.username,
          password: this.user.password,
        },
      })
        .then((resp) => {
          if (resp.status == 200) {
            if (resp.data !== null) {
              if (resp.data.active) {
                this.user = resp.data;
                this.$store
                  .dispatch("set_auth_success", {
                    user: resp.data,
                  })
                  .then(() => {
                    this.$helpers
                      .load_user_profile()
                      .then(() => {
                        this.$webpageEventBus.$emit("show_status", {
                          message: "Dobro došli " + this.user.name,
                          type: "primary",
                          timeout: 3000,
                        });
                        this.$router.push("/start");
                      })
                      .catch((e) => {
                        this.$webpageEventBus.$emit("show_status", {
                          message: e.message,
                          type: "error",
                          timeout: 3000,
                        });
                      });
                  });
              } else {
                this.$webpageEventBus.$emit("show_status", {
                  message: this.$t("deactivated"),
                  type: "error",
                  timeout: 3000,
                });
              }
            } else {
              this.$webpageEventBus.$emit("show_status", {
                message: this.$t("authorization_failed"),
                type: "error",
                timeout: 3000,
              });
            }
          } else {
            if (resp.status == 204) {
              this.$webpageEventBus.$emit("show_status", {
                message: this.$t("authorization_failed"),
                type: "error",
                timeout: 3000,
              });
            } else {
              this.$webpageEventBus.$emit("show_status", {
                message: resp.data.message,
                type: "error",
                timeout: 3000,
              });
            }
          }
        })
        .catch((err) => {
          this.$webpageEventBus.$emit("show_status", {
            message: err.message,
            type: "error",
            timeout: 3000,
          });
        })
        .finally(() => {
          this.is_btn_loading = false;
        });
    },
    handlePaymentResult(paymentResult) {
      if (paymentResult.status == "approved") {
        this.register_user()
          .then((resp) => {
            this.user.id = resp.data.id;
            this.register_payment(
              paymentResult.transaction_response.order_number +
                " / " +
                paymentResult.transaction_response.approval_code
            )
              .then((r_payment_resp) => {
                var payment_response = r_payment_resp.data.result;
                this.send_payment_email(payment_response)
                  .then(() => {
                    this.login_user();
                    this.is_btn_loading = false;
                  })
                  .catch((e) => {
                    this.$webpageEventBus.$emit("show_status", {
                      type: "error",
                      message: e.message,
                      timeout: 4000,
                    });
                  });
              })
              .catch((p_err) => {
                this.$webpageEventBus.$emit("show_status", {
                  type: "error",
                  message: p_err.message,
                  timeout: 4000,
                });
                this.is_btn_loading = false;
              });
          })
          .catch((e) => {
            alert(e);
          });
      } else {
        alert("Transakcija odbijena");
      }
    },
    company_check() {
      if (this.user.id_number !== null) {
        this.$http({
          method: "POST",
          url: "/auth/company_check",
          data: {
            id_number: this.user.id_number,
          },
        }).then((resp) => {
          this.user.company_exists = resp.data[0][0].COMPANY_EXISTS > 0;
          if (this.user.company_exists) {
            this.$webpageEventBus.$emit("show_status", {
              type: "error",
              message: "Firma već postoji, ili ID broj nije ispravan",
              timeout: 2000,
            });
          }
        });
      }
    },
    username_check() {
      if (this.user.username !== null && this.user.username.length > 1) {
        this.$http({
          method: "POST",
          url: "/auth/username_check",
          data: {
            username: this.user.username,
          },
        }).then((resp) => {
          this.user.username_exists = resp.data[0][0].USERNAME_EXISTS > 0;
          if (this.user.username_exists) {
            this.$webpageEventBus.$emit("show_status", {
              type: "error",
              message: "Korisničko ime već postoji",
              timeout: 2000,
            });
          }
        });
      }
    },
    email_check() {
      if (this.user.email !== null && this.user.email.length > 1) {
        this.$http({
          method: "POST",
          url: "/auth/email_check",
          data: {
            email: this.user.email,
          },
        }).then((resp) => {
          this.user.email_exists = resp.data[0][0].EMAIL_EXISTS > 0;
          if (this.user.email_exists) {
            this.$webpageEventBus.$emit("show_status", {
              type: "error",
              message: "Korisnički email već postoji",
              timeout: 2000,
            });
          }
        });
      }
    },
    register_payment(reference) {
      var valid_until = this.$moment(new Date())
        .add(this.selected_payment_option.months, "months")
        .local()
        .format("YYYY-MM-DD");
      return this.$http({
        method: "POST",
        url: "/accounts/register_payment",
        data: {
          user_id: this.user.id,
          amount: this.selected_payment_option.amount,
          payment_reference: reference,
          valid_until: valid_until,
          kom: this.selected_payment_option.months,
          discount: this.selected_payment_option.discount,
        },
      });
    },
    register_user() {
      return new Promise((resolve, reject) => {
        this.$http({
          method: "POST",
          url: "/accounts/update",
          data: {
            id: 0,
            name: this.user.company_name,
            address: this.user.address,
            id_number: this.user.id_number,
            vat_number: this.user.vat_number,
            telephone: this.user.phone,
            document_header: null,
            document_footer: null,
            payment_info: null,
            active: true,
            image_logo: null,
            image_stamp: null,
            image_signature: null,
            city: this.user.city,
            country: this.user.country,
            signatory: null,
            zip: this.user.zip,
            email: this.user.email,
          },
        })
          .then((resp) => {
            this.user.account_id = resp.data.id;
            this.user.telephone = this.user.phone;
            this.user.active_date = this.$moment(new Date())
              .local()
              .format("YYYY-MM-DD");
            this.$http({
              method: "POST",
              url: "/users/update",
              data: this.user,
            })
              .then((resp2) => {
                this.user.id = resp2.id;
                this.send_welcome_email();
                resolve(resp2);
              })
              .catch((e2) => {
                reject(e2);
              });
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    generate_payment_form() {
      this.validate()
        .then(() => {
          if (this.registration_type == 2) {
            if (this.selected_payment_option == null)
              this.selected_payment_option = this.payment_options[0];
            if (!this.user.username_exists) {
              this.payment_loading = true;
              let calculatedAmount =
                this.selected_payment_option.amount *
                this.selected_payment_option.months;
              calculatedAmount =
                calculatedAmount -
                (calculatedAmount * this.selected_payment_option.discount) /
                  100;
              const amountForMonri = calculatedAmount * 100;
              var post_object = {
                amount: amountForMonri,
              };
              this.$http({
                method: "POST",
                url: "/generate_payment_form",
                data: post_object,
              })
                .then((resp) => {
                  this.e6 = 3;
                  document.getElementById("card-element").innerHTML = "";
                  var components = monri.components({
                    clientSecret: resp.data.client_secret,
                  });
                  var style = {
                    base: {
                      fontSize: "16px",
                      color: "#195391",
                    },
                  };
                  card = components.create("card", { style: style });
                  card.mount("card-element");
                  card.onChange(function(event) {
                    var displayError = document.getElementById("card-errors");
                    if (event.error) {
                      displayError.textContent = event.error.message;
                      displayError.style.display = "block";
                    } else {
                      displayError.textContent = "";
                      displayError.style.display = "none";
                    }
                  });
                })
                .catch((err) => {
                  this.$webpageEventBus.$emit("show_status", {
                    type: "error",
                    message: err,
                    timeout: 2000,
                  });
                })
                .finally(() => {
                  this.payment_loading = false;
                  this.is_btn_loading = false;
                });
            } else {
              this.$webpageEventBus.$emit("show_status", {
                type: "error",
                message: "Korisničko ime je zauzeto",
                timeout: 2000,
              });
            }
          } else {
            this.register_user().then(() => {
              this.login_user();
              if (this.registration_type == 3) {
                this.send_enterprise_mail();
              }
              this.$webpageEventBus.$emit("show_status", {
                type: "success",
                message: "Uspješno ste se registrirali",
                timeout: 2000,
              });
            });
          }
        })
        .catch((e) => {
          this.$webpageEventBus.$emit("show_status", {
            type: "error",
            message: e,
            timeout: 2000,
          });
        });
    },
    validate() {
      return new Promise((resolve, reject) => {
        if (this.user.name == null || this.user.name.length < 1) {
          reject("Molimo unesite ime i prezime.");
        }
        if (
          this.user.email == null ||
          this.user.email.length < 1 ||
          !this.user.email.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/)
        ) {
          reject("Molimo unesite ispravnu email adresu.");
        }
        if (this.user.username == null || this.user.username.length < 1) {
          reject("Molimo unesite korisničko ime.");
        }
        if (this.user.password == null || this.user.password.lengt < 1) {
          reject("Molimo unesite lozinku.");
        }
        if (this.user.address == null || this.user.address.length < 1) {
          reject("Molimo unesite adresu.");
        }
        if (
          this.user.zip == null ||
          this.user.zip.length < 1 ||
          isNaN(this.user.zip)
        ) {
          reject("Molimo unesite poštanski broj.");
        }
        if (this.user.city == null || this.user.city.length < 1) {
          reject("Molimo unesite grad.");
        }
        if (this.user.phone == null || this.user.phone.length < 1) {
          reject("Molimo unesite telefonski broj.");
        }
        if (
          this.user.company_name == null ||
          this.user.company_name.length < 1
        ) {
          reject("Molimo unesite naziv firme.");
        }
        if (this.user.id_number == null || this.user.id_number.length < 1) {
          reject("Molimo unesite ID broj.");
        }
        if (this.user.vat_number == null || this.user.vat_number.length < 1) {
          reject("Molimo unesite PDV broj, ili 0 ako firma nije u PDVu.");
        }
        resolve();
      });
    },
    send_for_payment() {
      this.is_btn_loading = true;
      const transactionParams = {
        address: this.user.address,
        fullName: this.user.name,
        city: this.user.city,
        zip: this.user.zip,
        phone: this.user.phone,
        country: "BA",
        email: this.user.email,
        orderInfo: "Sabira.ba Licenca. Korisnik: " + this.user.name,
      };
      var vue_root = this;
      monri.confirmPayment(card, transactionParams).then((result) => {
        var errorElement = document.getElementById("card-errors");
        if (result.error) {
          errorElement.textContent = result.error.message;
          errorElement.style.display = "block";
        } else {
          errorElement.style.display = "none";
          this.user.payment = result;
          vue_root.handlePaymentResult(result.result);
        }
      });
    },
    open_registration(type) {
      this.registration_type = type;
      this.show_registration = true;
    },
    open_link(link) {
      window.open(link, "_blank");
    },
  },
};
</script>

<style scoped>
#payment-form label {
  text-transform: uppercase;
  font-size: 12px;
  width: 100%;
  margin-bottom: 10px;
  letter-spacing: 1.5px;
  color: #929397;
  height: 10px;
  white-space: pre-wrap;
  line-height: 15px;
  font-size: 16px;
  color: #663399;
}

#payment-form input {
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  padding-left: 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  border: none;
  border-bottom-color: currentcolor;
  border-bottom-style: none;
  border-bottom-width: medium;
  box-shadow: none;
  border-bottom: 1px solid #eee;
  border-radius: 0;
  color: #3e3e3e;
  letter-spacing: 1px;
  padding-left: 5px;
}

.sub_section {
  z-index: 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  height: 35rem;
  position: relative;
  overflow: hidden;
  text-align: center;
  display: grid;
  align-items: end;
  text-align: center;
  border-radius: 1.5rem;
  overflow: hidden;
}

.sub_section_bottom {
  display: grid;
  align-items: center;
  height: 25%;
}

.sub_section .text {
  font-size: 2rem;
}

.sub_section .description {
  font-size: 1.25rem;
}

.master_title {
  font-size: 3.5rem;
  text-align: center;
  width: 100%;
  font-weight: 700;
}

#card-errors {
  display: none;
  margin-top: 1rem;
  padding: 1rem;
  border: dashed 1px #333;
  color: #ff0000;
}

.footer_image {
  height: 2.5rem;
  display: inline-block;
}

.spacing_xl {
  margin: 10rem;
}

.spacing_lg {
  margin: 5rem;
}

.spacing_md {
  margin: 5rem;
}

.spacing_sm {
  margin: 5rem;
}

.spacing_xs {
  margin: 2rem 0rem 1rem 0;
}

.headline_xl {
  font-size: 5rem;
  line-height: 110%;
  margin-bottom: 1.5rem;
}

.headline_lg {
  font-size: 3rem;
  line-height: 110%;
  margin-bottom: 1.5rem;
}

.headline_md {
  font-size: 3rem;
  line-height: 110%;
  margin-bottom: 1.5rem;
}

.headline_sm {
  font-size: 2rem;
  line-height: 130%;
  margin-bottom: 1rem;
}

.headline_xs {
  font-size: 1.5rem;
  line-height: 130%;
  margin-bottom: 1rem;
}

.subtitle_xl {
  font-size: 3rem;
  line-height: 130%;
  opacity: 0.75;
  margin-bottom: 2rem;
}
.subtitle_lg {
  font-size: 1.5rem;
  line-height: 130%;
  opacity: 0.75;
  margin-bottom: 2rem;
}

.subtitle_md {
  font-size: 1.5rem;
  line-height: 130%;
  opacity: 0.75;
  margin-bottom: 2rem;
}

.subtitle_sm {
  font-size: 1.5rem;
  opacity: 0.75;
  margin-bottom: 2rem;
}

.subtitle_xs {
  font-size: 1.1rem;
  opacity: 0.75;
  margin-bottom: 2rem;
}

.video_xl {
  width: 100%;
  height: 630px;
}

.video_lg {
  width: 100%;
  height: 630px;
}

.video_md {
  width: 100%;
  height: 630px;
}

.video_sm {
  width: 560;
  height: 315px;
}

.video_xs {
  width: 560;
  height: 315px;
}

.module_xl {
  border-radius: 1.5rem !important;
  overflow: hidden;
  height: 40rem;
  display: grid;
  text-align: center;
  grid-template-rows: 1fr 1fr;
  grid-row-gap: 2rem;
  padding: 2rem;
}

.module_xl .icon {
  height: 8rem;
}

.module_xl .module_title {
  color: #fff;
  font-size: 2.5rem;
}

.module_xl .text {
  color: white;
  font-size: 1.5rem;
}

.module_lg {
  border-radius: 1.5rem !important;
  overflow: hidden;
  height: 32rem;
  display: grid;
  text-align: center;
  grid-template-rows: 1fr 1fr;
  grid-row-gap: 2rem;
  padding: 2rem;
}

.module_lg .icon {
  height: 5rem;
}

.module_lg .module_title {
  color: #fff;
  font-size: 2rem;
}

.module_lg .text {
  color: white;
  font-size: 1.2rem;
}

.module_md {
  border-radius: 1.5rem !important;
  overflow: hidden;
  height: 25rem;
  display: grid;
  text-align: center;
  grid-template-rows: 1fr 1fr;
  grid-row-gap: 2rem;
  padding: 2rem;
}

.module_md .icon {
  height: 5rem;
}

.module_md .module_title {
  color: #fff;
  font-size: 2rem;
}

.module_md .text {
  color: white;
  font-size: 1.2rem;
}

.module_sm {
  border-radius: 1.5rem !important;
  overflow: hidden;
  height: 28rem;
  display: grid;
  text-align: center;
  grid-template-rows: 1fr 1fr;
  grid-row-gap: 2rem;
  padding: 2rem;
}

.module_sm .icon {
  height: 4.2rem;
}

.module_sm .module_title {
  color: #fff;
  font-size: 2rem;
}

.module_sm .text {
  color: white;
  font-size: 1.2rem;
}

.module_xs {
  border-radius: 1rem !important;
  overflow: hidden;
  height: 24rem;
  display: grid;
  text-align: center;
  grid-template-rows: 1fr 1fr;
  grid-row-gap: 1rem;
  padding: 1.5rem;
}

.module_xs .icon {
  height: 4rem;
}

.module_xs .module_title {
  color: #fff;
  font-size: 1.5rem;
}

.module_xs .text {
  color: white;
  font-size: 1rem;
}

.footer_sm {
  text-align: center;
}

.footer_xl .footer_image {
  height: 2rem;
}

.footer_lg .footer_image {
  height: 2rem;
}
.footer_md .footer_image {
  height: 1.2rem;
}

.footer_sm .footer_image {
  height: 1.2rem;
}

.footer_xs .footer_image {
  height: 1.2rem;
}
.cta_xl {
  font-size: 2rem;
}

.cta_lg {
  font-size: 2rem;
}

.cta_xs {
  font-size: 1.4rem;
  font-weight: 400;
}

.menu_xs {
  border: solid 1px blue;
}

.menu_xs a {
  text-align: center;
  border: solid 1px red;
}

.hero_0_xl {
  height: 40rem;
  overflow: hidden;
  background-size: cover;
  border-radius: 1.5rem;
  background-position: center center;
}

.hero_1_xl {
  height: 40rem;
  overflow: hidden;
  background-size: cover;
  border-radius: 1.5rem;
  background-position: center center;
}

.hero_2_xl {
  height: 40rem;
  overflow: hidden;
  background-size: cover;
  border-radius: 1.5rem;
  background-position: center center;
}

.hero_0_lg {
  height: 28rem;
  overflow: hidden;
  background-size: cover;
  border-radius: 1.5rem;
  background-position: center center;
}

.hero_1_lg {
  height: 28rem;
  overflow: hidden;
  background-size: cover;
  border-radius: 1.5rem;
  background-position: center center;
}

.hero_2_lg {
  height: 28rem;
  overflow: hidden;
  background-size: cover;
  border-radius: 1.5rem;
  background-position: center center;
}
</style>
